var map = {
	"./admin-preguntas/admin-preguntas.module": [
		"./src/app/admin-preguntas/admin-preguntas.module.ts",
		"admin-preguntas-admin-preguntas-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./list/list.module": [
		"./src/app/list/list.module.ts",
		"list-list-module"
	],
	"./respuestas/respuestas.module": [
		"./src/app/respuestas/respuestas.module.ts",
		"common",
		"respuestas-respuestas-module"
	],
	"./resultados/resultados.module": [
		"./src/app/resultados/resultados.module.ts",
		"common",
		"resultados-resultados-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;